
import {getRezyme} from '../api/getRezyme';
import {setGetRezymeAction} from '../action';

const setGetRezyme = (params) => {
    return async (dispatch, getState) => {
        try {
            const {data} = await getRezyme(params);

            if (data.status === 'success') {
                dispatch(setGetRezymeAction({
                    data: data.data,
                    count: data.count
                }));           
            }
        } catch(error) {
            if (error && error.response && error.response.status === 401) {
                localStorage.removeItem('token');
                window.location.replace(window.location.origin);
            }
        }
    }
}

export {
    setGetRezyme
}